import React from "react";
import BeginningStages from "./components/BeginningStages";
import ComingSoonSteps from "./components/comingSoonSteps";
import PropertyInformation from "./components/propertyInformation";
import PrepForShowing from "./components/prepForShowings";
import OwnerReports from "./components/ownerReports";
import ProPhotos from "./components/proPhotos";
import InspectProperty from "./components/inspectProperty";
import SupportStaff from "./components/supportStaff";
import ShowingInspection from "./components/showingInspection";
import MowList from "./components/mowList";
import PlaceCodebox from "./components/placeCodebox";
import DelCityProperties from "./components/DelCityProperties";
import DelCityProcess from "./components/DelCityProcess";
import DelCityInspection from "./components/DelCityInspection";
import ListingReview from "./components/listingReview";
import ZillowVerification from "./components/zillowVerification";
import MapVerification from "./components/mapVerification";
import EndingManagment from "./components/endingManagment";
import Information from "./components/information";
import FAQLinks from "./components/FAQLinks";

const PropertyListing = ({ itemId, listId, checkedItems }) => {
  return (
    <div>
      {itemId === 1 && (
        <BeginningStages
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 2 && (
        <ComingSoonSteps
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 3 && (
        <PropertyInformation
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 4 && (
        <PrepForShowing
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 5 && (
        <OwnerReports
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 6 && (
        <ProPhotos
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 7 && (
        <InspectProperty
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 8 && (
        <SupportStaff
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 9 && (
        <ShowingInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 10 && (
        <MowList itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
      {itemId === 11 && (
        <PlaceCodebox
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 12 && (
        <DelCityProperties
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 13 && (
        <DelCityProcess
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 14 && (
        <DelCityInspection
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 15 && (
        <ListingReview
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 16 && (
        <ZillowVerification
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 17 && (
        <MapVerification
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 18 && (
        <EndingManagment
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 19 && (
        <Information
          itemId={itemId}
          listId={listId}
          checkedItems={checkedItems}
        />
      )}
      {itemId === 20 && (
        <FAQLinks itemId={itemId} listId={listId} checkedItems={checkedItems} />
      )}
    </div>
  );
};

export default PropertyListing;
